<template>
    <div class="bg-light pb-2 overflow-auto h-100">
        <header class="bg-white d-flex flex-row justify-content-between align-items-center">
            <div class="d-flex flex-row align-items-center p-2">
                <a class="me-2 fs-3 text-dark cp btn-rounded btn-default btn" @click="onBack()"
                    ><i class="mdi mdi-arrow-left"></i></a>



                <img
                    :src="user_details.image"
                    class="me-3"
                    style="border-radius: 50%; width: 2.5em; height: 2.5em"
                    v-if="user_details.image"
                />
                <h5 class="m-0">{{ user_details.name }}</h5>
            </div>
            <div class="d-flex flex-row px-3">
                <select class="form-select fw-600 text-muted me-2 w-auto" v-model="filter.month">
                    <option :value="month" v-for="month in 12" :key="month">
                        {{ format('2020-' + month + '-1') }}
                    </option>
                </select>
                <select class="form-select fw-600 text-muted" v-model="filter.year">
                    <option :value="year(i)" v-for="i in 3" :key="i">{{ year(i) }}</option>
                </select>
            </div>
        </header>
        <div class="p-3">
            <h4 class="main-title mb-3">Part 1: KEY RESULTS AREA AND KEY PERFORMANCE INDICATOR SUMMARY</h4>

            <div class="card card-body mb-3">
                <table class="table table-bordered m-0">
                    <thead class="bg-light">
                        <tr>
                            <th>Interpretation</th>
                            <th>Rating Scale</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Outstanding</td>
                            <td>101% and above</td>
                        </tr>
                        <tr>
                            <td>Meet Standard</td>
                            <td>90% - 100%</td>
                        </tr>
                        <tr>
                            <td>Does not meet standards</td>
                            <td>89% and below</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="card card-body mb-3">
                <table class="table table-bordered m-0" v-if="data.length">
                    <thead class="bg-light">
                        <tr>
                            <th class="text-center">Months</th>
                            <th class="text-center">KPI</th>
                            <th class="text-center">KRA</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(kra, i) in data" :key="i">
                            <td class="text-center">{{ format('2020-' + kra.MON + '-1') }}</td>
                            <td v-if="kra.KPI_ACHV == ''" class="text-center">{{ kra.KPI_ACHV_BR }}</td>
                            <td
                                v-else
                                class="text-center fw-700"
                                :class="{
                                    'text-danger': kra.KPI_ACHV === 'MISS',
                                    'text-success': kra.KPI_ACHV === 'HIT',
                                }"
                            >
                                {{ kra.KPI_ACHV }}
                            </td>
                            <td class="text-center">{{ parseFloat(kra.KRA_ACHV).toFixed(2) }}%</td>
                        </tr>
                    </tbody>
                </table>
                <div
                    class="d-flex flex-column justify-content-center align-items-center bg-white w-100 opacity-3"
                    v-else-if="data === false"
                >
                    <i class="mdi mdi-chart-box-outline h-auto" style="font-size: 100px"></i>
                    <span class="fw-500">Data is being generated</span>
                </div>
                <div
                    class="d-flex flex-column justify-content-center align-items-center bg-white w-100 opacity-3"
                    v-else
                >
                    <i class="mdi mdi-times-circle" style="font-size: 100px"></i>
                    <span class="fw-500">No Data found</span>
                </div>
            </div>

            <div class="card card-body mb-3">
                <table class="table m-0">
                    <tbody>
                        <tr>
                            <td class="border-0 fw-600">
                                KPI OVER-ALL AVERAGE: <strong>{{ kpi_average }}</strong>
                            </td>
                            <td class="border-0 fw-600">
                                KRA OVER-ALL AVERAGE: <strong>{{ kra_average }}</strong>
                            </td>
                        </tr>
                        <tr>
                            <td class="border-0 fw-600">
                                INTERPRETATION: <strong>{{ kpi_inter['inter'] }}</strong>
                            </td>
                            <td class="border-0 fw-600">
                                INTERPRETATION: <strong>{{ kra_inter['inter'] }}</strong>
                            </td>
                        </tr>
                        <tr>
                            <td class="border-0 fw-600">
                                x35%: <strong>{{ parseFloat(kpi_inter['value'] * 0.35).toFixed(2) }}</strong>
                            </td>
                            <td class="border-0 fw-600">
                                x35%: <strong>{{ parseFloat(kra_inter['value'] * 0.35).toFixed(2) }}</strong>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <h4 class="main-title mb-3">Interpretation Rating</h4>

            <div class="card card-body mb-3">
                <table class="table table-bordered m-0">
                    <thead class="bg-light">
                        <tr>
                            <th>Rating Scale</th>
                            <th class="text-center">Interpretation</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text-center fw-800">4</td>
                            <td>
                                Consistently exhibits the value/behavior with remarkable achievement that significantly
                                contributed to the department/organization
                            </td>
                        </tr>
                        <tr>
                            <td class="text-center fw-800">3</td>
                            <td>
                                Exhibits the value/behavior satisfactorily to meet the expected job output that
                                contributed to the department/organization.
                            </td>
                        </tr>
                        <tr>
                            <td class="text-center fw-800">2</td>
                            <td>
                                Sometimes exhibit the value/behavior, but not consistent enough to meet the expected job
                                output.
                            </td>
                        </tr>
                        <tr>
                            <td class="text-center fw-800">1</td>
                            <td>Does not or rarely exhibits the value/behavior to produce an expected job output.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="card card-body mb-3" v-for="(question_details, i) in questions" :key="i">
                <h4 class="main-title mb-3">Part : {{ i }}</h4>
                <table class="table table-bordered m-0">
                    <thead class="bg-light">
                        <tr v-if="!(i == ' 4 : DEVELOPMENT PLAN')">
                            <th>Rating Scale</th>
                            <th class="text-center" style="width: 20%" v-if="!(i == ' 4 : DEVELOPMENT PLAN')">
                                Interpretation:
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(questions, question_key) in question_details" :key="question_key">
                            <td>
                                {{ `${questions.quest_no}` }} <span v-html="formatQuestion(questions.vex_quest)"></span> 

                                  <div          
                                    class="d-flex flex-column"
                                    v-if="
                                        (parseInt(questions.emp_rate) === 4) && questions.part_def == 'BEHAVIORAL FACTORS'
                                    "
                                >
                                    <!-- <input type="text" class="form-control text-center mb-1 form-control-lg"   v-model="questions.answer" :disabled="!questions.isHead || questions.status === 'FWD'" v-if="questions.isHead"> -->
                                    <!-- {{formatQuestion(questions.vex_quest)}} -->

                                    <label class="mt-3 w-100 fw-600">Employee Answer <span class="text-danger">*</span></label>
                                    <textarea
                                        row="4"
                                        class="form-control mb-1 form-control-lg"
                                        style="font-size: 14px"
                                        v-model="questions.emp_answer"
                                        :disabled="  
                                            (!questions.isHead && !questions.isMe) ||
                                            (questions.isHead && !questions.isMe) ||
                                            questions.status === 'FWD'
                                            "
                                        placeholder="Input your answer here ..."
                                    >
                                    </textarea>
                                </div>

                                <div          
                                    class="d-flex flex-column"
                                    v-if="
                                        (parseInt(questions.sup_rate) === 4) && questions.part_def == 'BEHAVIORAL FACTORS'
                                    "
                                >
                                    <!-- <input type="text" class="form-control text-center mb-1 form-control-lg"   v-model="questions.answer" :disabled="!questions.isHead || questions.status === 'FWD'" v-if="questions.isHead"> -->
                                    <!-- {{formatQuestion(questions.vex_quest)}} -->

                                    <label class="mt-3 w-100 fw-600">Superior Answer <span class="text-danger">*</span></label>
                                    <textarea
                                        row="4"
                                        class="form-control mb-1 form-control-lg"
                                        style="font-size: 14px"
                                        v-model="questions.answer"
                                        :disabled="  questions.status === 'FWD'"
                                        placeholder="Input your answer here ..."
                                    >
                                    </textarea>
                                </div>


                                <div class="d-flex flex-column" v-if="questions.part_def == 'DEVELOPMENT PLAN'">
                        
                                    <textarea
                                        row="4"
                                        class="form-control mb-1 form-control-lg"
                                        style="font-size: 14px"
                                        v-model="questions.answer"
                                        :disabled=" questions.status === 'FWD' || ((questions.id != '15' && !questions.isHead)  || (questions.id == '15' && !questions.isMe))"
                                        placeholder="Input your answer here ..."
                                    >
                                    </textarea>
                                </div>
                            </td>

                            <td v-if="!(questions.part_def == 'DEVELOPMENT PLAN')">
                                <div class="d-flex flex-row">
                                    <div
                                        class="flex-1 px-1 fw-600"
                                        v-if="
                                            (!questions.isHead && questions.part_def == 'BEHAVIORAL FACTORS') ||
                                            (questions.isHead && questions.part_def == 'BEHAVIORAL FACTORS')
                                        "
                                    >
                                        <input
                                            type="number"
                                            class="form-control text-center mb-1 form-control-lg"
                                            min="1"
                                            max="4"
                                            v-model="questions.emp_rate"
                                            onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                                            :disabled="
                                                (!questions.isHead && !questions.isMe) ||
                                                (questions.isHead && !questions.isMe) ||
                                                questions.status === 'FWD'
                                            "
                                            @input="validate($event, question_key, i, 'emp_rate')"
                                        />

                                        Employee
                                    </div>
                                    <div class="flex-1 px-1 fw-600">
                                        <input
                                            type="number"
                                            class="form-control text-center mb-1 form-control-lg"
                                            min="1"
                                            max="4"
                                            v-model="questions.sup_rate"
                                            onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                                            :disabled="
                                                (questions.part_def != 'BEHAVIORAL FACTORS' && !isHRhead) ||
                                                (questions.part_def == 'BEHAVIORAL FACTORS' && !questions.isHead) ||
                                                questions.status === 'FWD' ||
                                                (questions.isMe && !isMe)
                                            "
                                            @input="validate($event, question_key, i, 'sup_rate')"
                                        />

                                        <span v-if="questions.part_def != 'BEHAVIORAL FACTORS'"> Human Resource </span>
                                        <span v-else> Superior </span>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <tr v-if="!(i == ' 4 : DEVELOPMENT PLAN')">
                            <td class="text-center">
                                <strong> Total Rate </strong>
                            </td>
                            <td class="text-center">
                                <span v-if="i == ' 2 : BEHAVIORAL FACTORS'">
                                    <!-- <span v-html="behavioralRating">
                      
                                </span> -->
                                    {{ Number.parseFloat(behavioralRating.average).toFixed(2) }} X
                                    {{ behavioralRating.part_perc }}% :
                                    <strong>{{ behavioralRating.total_rate }}</strong>
                                </span>

                                <span v-if="i == ' 3 : ATTENDANCE'">
                                    <!-- <span v-html="attendanceRating">
                                </span> -->

                                    {{ attendanceRating.sup_rate }} X {{ attendanceRating.part_perc }}% :
                                    <strong>{{ attendanceRating.total_rate }}</strong>
                                </span>
                                <span v-if="i == ' 4 : MEMO on DISCIPLINARY ACTION (MDA)'">
                                    <!-- <span v-html="memoRating">
                                </span> -->

                                    {{ memoRating.sup_rate }} X {{ memoRating.part_perc }}% :
                                    <strong>{{ memoRating.total_rate }}</strong>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <h4 class="main-title mb-3">Overall Rating</h4>

            <div class="card card-body mb-3">
                <table class="table table-bordered m-0">
                    <thead class="bg-light">
                        <tr>
                            <th class="text-center"></th>
                            <th class="text-center">Percentage</th>
                            <th class="text-center">Rate</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>KEY RESULTS AREA (KRA)</td>
                           
                            <td class="text-center">35%</td>
                            <td class="text-center">{{ parseFloat(kpi_inter['value'] * 0.35).toFixed(2) }}</td>
                        </tr>
                        <tr>
                            <td>KEY PERFORMANCE INDICATOR (KPI)</td>
                            <td class="text-center">35%</td>
                            <td class="text-center">{{ parseFloat(kra_inter['value'] * 0.35).toFixed(2) }}</td>
                        </tr>
                        <tr>
                            <td>BEHAVIORAL FACTORS</td>
                            <td class="text-center">20%</td>
                            <td class="text-center">
                                {{
                                    behavioralRating.total_rate == undefine || isNaN(behavioralRating.total_rate)
                                        ? '0.00'
                                        : behavioralRating.total_rate
                                }}
                            </td>
                        </tr>
                        <!-- <tr>
                            <td>ATTENDANCE</td>
                            <td class="text-center">10%</td>
                            <td class="text-center">
                                {{
                                    attendanceRating.total_rate == undefined || isNaN(attendanceRating.total_rate)
                                        ? '0.00'
                                        : attendanceRating.total_rate
                                }}
                            </td>
                        </tr> -->
                        <tr>
                            <td>MEMO on DISCIPLINARY ACTION (MDA)</td>
                            <td class="text-center">10%</td>
                            <td class="text-center">
                                {{
                                    memoRating.total_rate == undefined || isNaN(memoRating.total_rate)
                                        ? '0.00'
                                        : memoRating.total_rate
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td class="text-center">
                                <strong> Total Rate </strong>
                            </td>
                            <td class="text-center fw-800">
                                {{ isNaN(totalrate) ? '0.00' : totalrate }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="w-100" v-if="(!isPosted && isHead) || (!isPosted && isMe) || (isHRhead && !isPosted)">
         

                <button class="btn btn-dark btn-lg px-5 ml-auto" @click="save()" v-if="!isSaving ">Save</button>
                <button class="btn btn-dark btn-lg px-5 ml-auto" disabled v-else>
                            <div class="spinner-border text-primary" role="status">
                    </div>
                    Saving...

                </button>
                
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { groupBy } from 'underscore';

export default {
    data() {
        return {
            filter: {
                year: moment().format('YYYY'),
                month: moment().format('M'),
            },
            start: 1,
            data: [],
            questions: [],
            user_details: {
                image: '',
                name: '',
                employee_id: '',
            },
            changeMe: 'Unchanged',
            behavioralRating: [],
            attendanceRating: [],
            memoRating: [],
            isSaving : false
        };
    },
    computed: {
        isHead() {
            var question_header = this.questions;
            for (var key in question_header) {
                var questions = question_header[key]; // question_header['ATTENDANCE'];
                for (var i = 0; i < questions.length; i++) {
                    var question = questions[i];
                    return question['isHead'];
                }
            }

            return false;
        },

        isMe() {
            var question_header = this.questions;
            for (var key in question_header) {
                var questions = question_header[key]; // question_header['ATTENDANCE'];
                for (var i = 0; i < questions.length; i++) {
                    var question = questions[i];
                    return question['isMe'];
                }
            }

            return false;
        },

        isHRhead() {
            var question_header = this.questions;
            for (var key in question_header) {
                var questions = question_header[key]; // question_header['ATTENDANCE'];
                for (var i = 0; i < questions.length; i++) {
                    var question = questions[i];
                    return question['isHRhead'];
                }
            }

            return false;
        },

        isPosted() {
            var question_header = this.questions;
            // const p = question_header.map(e => e.status);

            let p = []
            for (var key in question_header) {
                var questions = question_header[key]; // question_header['ATTENDANCE'];
                
                for (var i = 0; i < questions.length; i++) {
                    var question = questions[i];
                    // if(question['status'] === 'FWD') return true;
                    // else return false;
                    // return question['status'] === 'FWD'; // ATV FWD, true false

                    p.push({part_def : question['part_def'], status :  question['status']});
                }
            }
            //CHECK IF ALL QUESTION STATUS IS FWD

            let pp = groupBy(p,p => p.part_def)

            if(this.isMe || this.isHead) return pp["BEHAVIORAL FACTORS"].map(el => el.status).every(el => el == 'FWD');
            
            if(this.isHRhead ) return pp["MEMO on DISCIPLINARY ACTION (MDA)"].map(el => el.status).every(el => el == 'FWD');
            return p.every(el => el == 'FWD');
        },
        totalrate() {
            let total = 0;

            if (this.behavioralRating) {
                total = total + parseFloat(this.behavioralRating.total_rate);
            }
  
            // if (this.attendanceRating) {
            //     total = total + parseFloat(this.attendanceRating.total_rate);
            // }

            if (this.memoRating) {
                total = total + parseFloat(this.memoRating.total_rate);
            }

            total = total + parseFloat(this.kpi_inter['value'] * 0.35);
            total = total + parseFloat(this.kra_inter['value'] * 0.35);

            total = Number.parseFloat(total).toFixed(2);

            return total;
        },
        kra_average() {
            let avg = 0;
            let d = 0;
            if (!this.data.length) return avg;

            this.data.forEach((el) => {
                let n = el.KRA_ACHV;
                if (!isNaN(n) && n > 0) {
                    avg += parseFloat(n);
                    d++;
                }
            });

            if (d === 0) d = 1; // TO PREVENT UNDEFINED

            avg = parseFloat(avg / d).toFixed(2);

            return avg;
        },
        kpi_average() {
            let avg = 0;
            let d = 0;
            let s = 0,
                f = 0;

            if (!this.data.length) return avg;

            this.data.forEach((el) => {
                let n = el.KPI_ACHV;
                // if(n.toString().trim() === '') n = el.KPI_ACHV_BR;

                if (n.toString().trim() !== '') d++;
            });


            //Loop yung data
            this.data.forEach((el) => {
                let n = el.KPI_ACHV;

                //Pag HIT  di ko alam mga nilagay ni livee na variable ee
                if (n.toString().trim() === 'HIT') {
                    avg++; //average
                    s++; //eto
                } else if (n.toString().trim() === '' && el.KPI_ACHV_BR !== null) {
                    let a = el.KPI_ACHV_BR; 
                    avg += parseFloat(a);
                    d++; //eto yung i-didivide pagmerong hindi HIT
                    console.log('avg', avg)
                }

                f++;
                // if(n.toString().trim() === 'HIT') avg++;
            });

            if (d === 0) d = 1; // TO PREVENT UNDEFINED eto nakalagayt na

  
           
            if (this.data[this.data.length - 1].KPI_ACHV_BR !== null) {
                avg = parseFloat(avg / d).toFixed(2) //avg / d eto dinivide na para makuha average
                console.log('avg 1', avg)
            }
           else if (this.data[this.data.length - 1].KPI_ACHV !== '') {
                avg = parseFloat(avg / d).toFixed(2) * 100;
                console.log('d 2', d)

                console.log('avg 2', avg)
            }

            //DITO SYA PUMASOK yung f is length ng data yan tapos yung s, success ata yan haha
            if (s == f) {
                 avg = parseFloat(s / f).toFixed(2) * 100;
                 console.log('avg 3', avg)
            }
           

            return avg;
        },
        kpi_inter() {
            //so kaya .60 parin kasi yung return ni kpi_average is 1.00
            //parang mali 
            //kinukuha average this.kpi_average;
            // let n = this.kpi_average;
            let n = this.kpi_average
            //  let n = 200;
            // let inter = ''
            let data = {
                inter: '',
                value: 0,
            };

    //pwedeng ganyan or  sa  let n = this.kpi_average * 100; same parin yan
            //tapos ganto yung condition
            if (n == 0) (data['inter'] = 'Does not meet standard'), (data['value'] = 2);
            if (n < 90 && n != 0) (data['inter'] = 'Does not meet standard'), (data['value'] = 2); //so dito parin bagsak nya
            if (n >=90) (data['inter'] = 'Meet Standard'), (data['value'] = 3);
            if (n >= 101) (data['inter'] = 'Outstanding'), (data['value'] = 4);

            return data;
        },

        kra_inter() {
            let n = this.kra_average;
            //  let n = 200;
            let data = {
                inter: '',
                value: 0,
            };

            if (n == 0) (data['inter'] = 'Does not meet standard'), (data['value'] = 2);
            if (n < 90 && n != 0) (data['inter'] = 'Does not meet standard'), (data['value'] = 2);
            if (n >= 90) (data['inter'] = 'Meet Standard'), (data['value'] = 3);
            if (n >= 101) (data['inter'] = 'Outstanding'), (data['value'] = 4);

            return data;
        },

        ratingCompute(type) {
            return type;
        },
    },
    methods: {
        validate(e, key, i, type) {
            let { value } = e.target;


            if (!value) return;

            if(value > 4)   this.questions[i][key][type] = 4
            
            if (value % 1 !== 0) {
        
   
                let newNumber = Math.floor(value);
                this.questions[i][key][type] = newNumber;
            }
      
            // if (this.questions[i][key][type] == 4 || this.questions[i][key][type] == '4') {
            //    if(type == 'emp_rate'){
            //                this.questions[i][key].answer += `Employee's Answer: `
            //    }
            //    else if(type == 'sup_rate'){
            //                 if(this.questions[i][key].answer) this.questions[i][key].answer = this.questions[i][key].answer.replace(/(\r\n|\n|\r)/gm," ")
            //                 this.questions[i][key].answer += `\nSuperior's Answer: `
                        
            //    } 
            // }
          
            // else{
            //     if(this.questions[i][key].answer !== null || this.questions[i][key].answer !== '' ){
            //         let sup_ans = this.questions[i][key].answer.search("Superior's Answer: ");

            //       //  console.log( this.questions[i][key].answer.)
            //         if(sup_ans != -1){
            //              this.questions[i][key].answer =  this.questions[i][key].answer.subnstring(this.questions[i][key].answer.search("Superior's Answer: "),this.questions[i][key].answer)
            //         }
                    
            //     }
            // }

        },
        computeRating() {
            // var question_header = this.questions;

            for (var key in this.questions) {
                let data = this.questions[key]; //this.question['ATTENDACE']

                if (key == ' 2 : BEHAVIORAL FACTORS') {
                    let emp_rate = 0;
                    let sup_rate = 0;
                    let emp_total_rate = 0;
                    let sup_total_rate = 0;
                    let part_perc = 0;
                    let average = 0;
                    let total_rate = 0;

                    data.forEach(function (row) {
                        emp_rate = emp_rate + row.emp_rate * 1;
                        sup_rate = sup_rate + row.sup_rate * 1;
                        part_perc = row.part_perc * 1;
                    });

                    emp_total_rate = (emp_rate / data.length) * 0.4;
                    sup_total_rate = (sup_rate / data.length) * 0.6;
                    average = emp_total_rate + sup_total_rate;
                    total_rate = (average * part_perc) / 100;

                    total_rate = total_rate.toFixed(2);
                    // this.behavioralRating = `<span> ${average} x  ${part_perc}% : <strong> ${total_rate} </strong> </span>`
                    this.behavioralRating = {
                        average,
                        part_perc,
                        total_rate,
                    };
                
                } 
                // else if (key == ' 2 : ATTENDANCE') {
                //     let sup_rate = 0;
                //     let part_perc = 0;
                //     let total_rate = 0;
                //     let average = 0;
                //     data.forEach(function (row) {
                //         sup_rate = sup_rate + row.sup_rate * 1;
                //         part_perc = row.part_perc * 1;
                //     });

                //     average = sup_rate / data.length;
                //     total_rate = (average * part_perc) / 100;
                //     total_rate = total_rate.toFixed(2);
                //     // this.attendanceRating = `<span> ${sup_rate} x  ${part_perc}% : <strong> ${total_rate} </strong> </span>`
                //     this.attendanceRating = {
                //         sup_rate,
                //         part_perc,
                //         total_rate,
                //     };
                // } 
                
                
                else if (key == ' 3 : MEMO on DISCIPLINARY ACTION (MDA)') {
                    let sup_rate = 0;
                    let part_perc = 0;
                    let total_rate = 0;
                    let average = 0;
                    data.forEach(function (row) {
                        sup_rate = sup_rate + row.sup_rate * 1;
                        part_perc = row.part_perc * 1;
                    });

                    average = sup_rate / data.length;
                    total_rate = (average * part_perc) / 100;
                    total_rate = total_rate.toFixed(2);
                    // this.memoRating = `<span> ${sup_rate} x  ${part_perc}% : <strong> ${total_rate} </strong> </span>`
                    this.memoRating = {
                        sup_rate,
                        part_perc,
                        total_rate,
                    };
                }

                // 3 : ATTENDANCE
                // 4 : MEMO on DISCIPLINARY ACTION (MDA)
            }
        },
        formatQuestion(string) {
            var question = string.toString().replaceAll('\r\n', '<br>');
            return question;
        },
        format(date = '') {
            return moment(new Date(date)).format('MMMM');
        },
        year(minus = 0) {
            minus -= 1;
            return moment().subtract(minus, 'years').format('YYYY');
        },
        async loadKRA() {
            this.data = false;

            // var salesman = 'LEATICe';
            // var salesman = function() {}

            // let salesman = 'SALESMAN-CODE';
            // salesman = function() {}

            // const salesman = 1;
            // salesman = 2 //bawal

            // const salesmans = [];
            // salesmans.push('LEATRICE-C'); //pwede

            var salesman_code = this.$route.params.salesman_code;

            // `/appraisal/kra_table?year=${this.filter.y}&month=&salesman_code=`
            // '/appraisal/kra_table?year='+this.filter.y+'&month=&salesman_code';

            await this.$axios
                .get(
                    `/appraisal/kra_table?year=${this.filter.year}&month=${this.filter.month}&salesman_code=${salesman_code}`,
                )
                .then((res) => {
                    this.data = res.data;
                })
                .catch(() => {
                    this.data = [];
                });
        },

        async loadQuestions() {
            var salesman_code = this.$route.params.salesman_code;
            // this.filter.year =  this.$route.params.year;
            //     this.filter.month =  this.$route.params.month;
            //pending
            this.questions = false;
            await this.$axios
                .get(
                    `/appraisal/questions?year=${this.filter.year}&month=${this.filter.month}&salesman_code=${salesman_code}`,
                )
                .then((res) => {
                    let formData = res.data;
                    for (let key in formData) {
                        if (key.trim() != '5 : DEVELOPMENT PLAN') {
                            formData[key].forEach((el) => {
                                el.sup_rate = el.sup_rate * 1;
                                el.emp_rate = el.emp_rate * 1;
                            });
                        }
                    }

                    this.questions = formData;
                    //Compute the Rating
                    this.computeRating();
                    // console.log(this.questions)
                })
                .catch(() => {
                    this.questions = [];
                });
        },

        async loadSalesmanDetails() {
            var salesman_code = this.$route.params.salesman_code;
            await this.$axios
                .get(`/appraisal/salesman?salesman_code=${salesman_code}`)
                .then((res) => {
                    this.user_details = res.data;
                    // console.log(this.user_details)
                })
                .catch(() => {
                    this.user_details = {
                        image: '',
                        name: '',
                    };
                });
        },

        async save() {
            // LOOP QUESTIONS
            this.isSaving = true
            // array_merge()
            var answers = [];
            //var j = -1;
            for (var key in this.questions) {
                var data = this.questions[key]; // this.questions['ATTENDANCE'];

               

                // 0 1 2 3 4 5

                for (var subkey in data) {
                    var question = data[subkey]; //data[0];
                     
                     if(question.part_def == 'BEHAVIORAL FACTORS'){
                        if( question.sup_rate < 4) question.answer = " ";
                        if(question.emp_rate < 4 ) question.emp_answer = " ";
                            
                     }
         
                    if (this.isHead)  answers.push(question);
                     else if (!this.isHead && (question.part_def == 'BEHAVIORAL FACTORS' || question.part_def == 'DEVELOPMENT PLAN' ))  answers.push(question);
                     else if (this.isHRhead && question.isHRhead) answers.push(question);
                    
                }

                // for(var i = 0; i < data.length; i++) { // [0,1,2,3,4,5,6]
                //     j++;

                //     console.log(question, j);
                //     //answers.push(question);
                // }

                // if(answers.length === 0) {
                //     console.log(data);
                //     answers = data; // TO REPLACE { 1 - 9: ...}
                // }
                // else {
                //     console.log(data);
                //             // 0 - 9          10
                //     answers = answers.concat(data); // TO MERGE //problem here { 1 - 9: ..., 10: ... }, { 1 - 9: ..., 10 : { 10: ... } }
                //     console.log(answers);
                //     return;
                // }
            }

            var salesman_code = this.$route.params.salesman_code;
            // console.log(answers)
            // console.log(salesman_code)

            // console.log(answers);
            // console.log(salesman_code);

            await this.$axios
                .post(
                    `/appraisal/insert_answers`,
                    this.$qs.stringify({
                        answers: answers,
                        salesman_code: salesman_code,
                        year: this.filter.year,
                        month: this.filter.month,
                    }),
                )
                .then((res) => {
                    this.loadQuestions();
                    this.$jlalert.show(res.data, false);
                })
                .catch((err) => {
                    this.$jlalert.show(err);
                })
                .finally(() => {
                    this.isSaving = false
                });

            // console.log(answers);
        },

        onBack() {
            // if(this.isHead || this.isHRhead) this.$router.push('/appraisal');
            // else this.$router.push('/');
            this.$router.back();

        }
    },

    mounted() {
        this.filter.year =  this.$route.params.year;
        this.filter.month =  this.$route.params.month;
        this.loadSalesmanDetails(); //for salesman details
        this.loadKRA(); //kra table ;miss and hit
        this.loadQuestions();

        setTimeout(() => {
            this.changeMe = 'changed';
        }, 2000);
    },
    watch: {
        '$route.params.salesman_code': function (newVal) {
            if (newVal !== undefined) {
                this.loadSalesmanDetails();
                this.loadKRA();
                this.loadQuestions();
            }
        },
        'filter.month': function (newVal) {
            if (newVal !== undefined || newVal !== 0) {
      
        //         this.$route.params.month = newVal
        //         this.$route.path = 'test'
        //   console.log(this.$router)
             this.$router.push(`/appraisal/${this.$route.params.salesman_code}/${this.filter.year}/${this.filter.month}`);

                this.loadSalesmanDetails();
                this.loadKRA();
                this.loadQuestions();
            }
        },
        'filter.year': function (newVal) {
            if (newVal !== undefined || newVal !== 0) {
                this.$router.push(`/appraisal/${this.$route.params.salesman_code}/${this.filter.year}/${this.filter.month}`);
                this.loadSalesmanDetails();
                this.loadKRA();
                this.loadQuestions();
            }
        },
    },
};
</script>

<style scoped>
.main-title {
    background: var(--primary-color);
    border-radius: 4px;
    padding: 10px;
    font-size: 1.2em;
    color: #ffffff;
}
</style>
